// extracted by mini-css-extract-plugin
export default {"wrapper":"specifications__wrapper___16iQl","image":"specifications__image___3LuAb","label":"specifications__label___3sKmO"};